import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Attraction, FLAG_FREE_CANCELLATION, FLAG_LIKELY_TO_SELL_OUT, SHOW_ATTRACTION_PRICE } from '../../models/attraction.model';
import { heroImageUrl, formatAttractionPrice } from '../attraction-utils';

/**
 * Vertical list row (Android `AttractionCard`): 96px image + title + rating + flag chips + price.
 * A hand-built row with a border, matching the app's surface-with-border card idiom (no elevation).
 */
@Component({
    selector: 'app-attraction-card',
    templateUrl: './attraction-card.component.html',
    styleUrls: ['./attraction-card.component.scss'],
    host: { class: 'attractions-scope' },
    standalone: false
})
export class AttractionCardComponent {
  @Input() attraction!: Attraction;
  @Output() cardClick = new EventEmitter<string>();

  readonly FLAG_FREE_CANCELLATION = FLAG_FREE_CANCELLATION;
  readonly FLAG_LIKELY_TO_SELL_OUT = FLAG_LIKELY_TO_SELL_OUT;

  get imageUrl(): string | null {
    return heroImageUrl(this.attraction);
  }

  get price(): string | null {
    return SHOW_ATTRACTION_PRICE
      ? formatAttractionPrice(this.attraction.starting_price, this.attraction.currency)
      : null;
  }

  get flags(): string[] {
    return this.attraction.flags ?? [];
  }

  hasFlag(flag: string): boolean {
    return this.flags.indexOf(flag) !== -1;
  }

  onClick(): void {
    if (this.attraction.provider_product_id) {
      this.cardClick.emit(this.attraction.provider_product_id);
    }
  }
}
